import { ensureVersionValid } from 'components/vendor/MultiProductWidget/ensureValid'

export const HELPER_ID = 'even-iframe-helper'
export const CNF_HELPER_ID = 'CNF-iframe-helper'
export const THEME_QUERY_PARAM_PREFIX = 'theme.'
export const EMBED_URL = 'https://embed.hifiona.com/ui/multi-product/index.html'
export const EMBED_URL_WITH_OVERRIDE = (override = '') =>
	`https://embed.hifiona.com${ensureVersionValid(override)}/ui/multi-product/index.html`
export const EMBED_HELPER_SCRIPT_URL = 'https://embed.hifiona.com/script/helper/bundle.js'

export const CNF_EMBED_HELPER_SCRIPT_URL_MAP: Partial<Record<string, string>> = {
	loan: 'https://www.moneylion.com/network/fiona/cnf-loans/web-component/lending-search/index.js',
	credit_card: 'https://www.moneylion.com/network/fiona/credit-cards/web-component/credit-cards/index.js'
}

export const MIGRATED_CNF_EMBED_COMPONENTS_MAP: Partial<Record<string, () => JSX.Element>> = {
	//@ts-ignore - web-components must not be self-closing
	loan: () => <moneylion-lending-search></moneylion-lending-search>,
	//@ts-ignore - web-components must not be self-closing
	credit_card: () => <moneylion-credit-cards></moneylion-credit-cards>
}

export const EMBED_ACCESS_TOKENS: { [key: string]: string } = {
	loan: 'd6aa498c-0bd2-4409-a67b-7d7587ebe32b_6abfb209-8dcd-4c46-9d4b-683f6cced9f5',
	credit_card: 'ce0cb96b-4c14-4f26-93ac-905d9c0d050e_b473ea3b-fd64-4db5-9117-0c3dab8906b2',
	deposits: '701a1b86-a217-43cb-8cd4-39d38549cfe5_ea78268b-172d-43ad-99a9-291d475a1516',
	life_insurance: '0e1a6635-55a0-4df1-89e2-7bfc6f8e75ba_1d3048d3-c085-414a-a226-825bf1ff63ba',
	student_loan_refinance: '44ca236e-47e9-4f93-b857-697a073c87ed_c9338bb1-53b1-4658-a9f6-99a9f8fb16c0',
	loan_sem: '5940a32d-051b-4b11-be71-2ce33e0e60ab_39c83299-1757-4f5f-bc64-7470732eea47'
}

export const EMBED_COMPANY_UUIDS: { [key: string]: string } = {
	loan: '5eeab848-2ab7-43b0-aa78-879868f0a327',
	credit_card: '336c3f6d-d496-47ab-827b-43c733833474',
	deposits: 'aaac14ee-2db6-4a16-9759-35424e86a25d',
	life_insurance: 'c9eae6d4-5187-4337-979a-c3ea54698600',
	student_loan_refinance: '9adeb426-20a6-4ad6-8dd6-4f4299b2bc94',
	loan_sem: '97678c82-c45c-4882-a051-d2931c6f0c48'
}

export const DEFAULT_FIONA_THEME_PARAMS = {
	borderRadiusLarge: '4px',
	borderRadiusSmall: '4px',
	colorBackgroundSecondary: '#fff'
}

export const DEFAULT_FIONA_EMBED_PARAMS = Object.assign(
	{},
	...Object.entries(DEFAULT_FIONA_THEME_PARAMS).map(([k, v]) => ({ [`${THEME_QUERY_PARAM_PREFIX}${k}`]: v }))
)

export const EMBED_PRODUCTS = {
	LOAN: 'loan',
	CREDIT_CARD: 'credit_card',
	DEPOSITS: 'deposits',
	LIFE_INSURANCE: 'life_insurance',
	MORTGAGE: 'mortgage'
}

export const EMBED_PARTNERS = {
	FIONA_CC: 'fiona_cc',
	FIONA: 'fiona',
	FIONA_SLR: 'fiona-slr',
	FIONA_LIFE: 'fiona'
}
